<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">
  div
    div.c-auth-page__head
      h1 {{ $t('h1') }}
      h2 {{ $t('h2') }}

    form-forgot-password
    router-link.link-btn.enter-number(v-bind:to={'name': 'enter-number'}) {{ $t('enter-number') }}  
</template>

<script>
import { mapGetters } from 'vuex';

import formForgotPassword from '../form-forgot-password/component';

export default {
  components: {
    formForgotPassword,
  },

  computed: {
    ...mapGetters('registration', ['smsCodeValid']),
  },

  mounted() {
    if (this.smsCodeValid !== true) {
      this.$router.push({ name: 'enter-number' });
    }
  },
};
</script>

<style scoped>
.enter-number {
  margin-top: 16px;
}
</style>
